module.exports = "/static/media/article06.35585256.jpg";